import { useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function AuthCallback() {
    useEffect(() => {
        // Handle the auth callback
        supabase.auth.onAuthStateChange((event, session) => {
            if (event === 'SIGNED_IN' && session) {
                // Redirect to home page after successful sign in
                window.location.href = '/';
            } else if (event === 'SIGNED_OUT') {
                // Clear any local storage/session data and redirect to login
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/';
            } else if (event === 'TOKEN_REFRESHED') {
                // Token was refreshed, user is still authenticated
                // No action needed, the session will be updated automatically
            } else if (event === 'PASSWORD_RECOVERY') {
                // Handle password recovery if applicable
                // Could redirect to a password reset page
            }
        });
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Completing sign in...</p>
            </div>
        </div>
    );
}
